import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT, HAS_INSTANT_DISCOUNT } from '../../../constants';

import { scrollToAnchor } from '../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import { TermsPageContainer } from './TermsPageStyle';
import { getI18nByApp } from '../../../services/i18n/selector';

class TermsPage extends React.Component {
    componentDidMount() {
        scrollToAnchor(this.props.location);
    }

    componentDidUpdate() {
        scrollToAnchor(this.props.location);
    }

    render() {
        const { i18n, i18nCommon } = this.props;

        const discounted = HAS_INSTANT_DISCOUNT ? i18nCommon.DISCOUNTED : '';
        const discountedPlural = HAS_INSTANT_DISCOUNT ? i18nCommon.DISCOUNTED_PLURAL : '';

        return (
            <TermsPageContainer className="conteneur conteneur-mobile">
                <HeadComponent
                    title={getI18nByApp(i18n, 'page.TERMS.TITLE')}
                    description={getI18nByApp(i18n, 'page.TERMS.DESCRIPTION')}
                />
                <LocalizedBreadcrumbItem to={PATH.TERMS_PATH}>
                    {getI18nByApp(i18n, 'page.TERMS.BREADCRUMB')}
                </LocalizedBreadcrumbItem>
                <h1>{getI18nByApp(i18n, 'page.TERMS.TITLE')}</h1>

                <h3>{getI18nByApp(i18n, 'page.TERMS.TITLE1')}</h3>
                <p>
                    {convertHtmlToReactDomWithParams(
                        getI18nByApp(i18n, 'page.TERMS.TEXT1_1'),
                        CONTEXT_ROOT
                    )}
                </p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT1_2')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT1_3')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT1_4')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT1_5')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT1_6')}</p>

                <h3>{getI18nByApp(i18n, 'page.TERMS.TITLE2')}</h3>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT2_1')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT2_3')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT2_2')}</p>

                <h3>{getI18nByApp(i18n, 'page.TERMS.TITLE3')}</h3>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT3_1')}</p>
                <ul>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT3_2')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT3_3')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT3_4')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT3_5')}</li>
                </ul>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT3_6')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT3_7')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT3_8')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT3_9')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT3_10')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT3_11')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT3_12')}</p>

                <h3>{getI18nByApp(i18n, 'page.TERMS.TITLE4')}</h3>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT4_1')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT4_2')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT4_3')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT4_4')}</p>
                <ul>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT4_5')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT4_6')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT4_7')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT4_8')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT4_9')}</li>
                    <li>
                        {convertHtmlToReactDomWithParams(
                            getI18nByApp(i18n, 'page.TERMS.TEXT4_10'),
                            discountedPlural
                        )}
                    </li>
                </ul>

                <h3>{getI18nByApp(i18n, 'page.TERMS.TITLE5')}</h3>
                <p>
                    {convertHtmlToReactDomWithParams(
                        getI18nByApp(i18n, 'page.TERMS.TEXT5_1'),
                        discountedPlural
                    )}
                </p>
                <p>
                    {convertHtmlToReactDomWithParams(
                        getI18nByApp(i18n, 'page.TERMS.TEXT5_2'),
                        discounted
                    )}
                </p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT5_3')}</p>
                <ul>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT5_4')}</li>
                </ul>

                <h3>{getI18nByApp(i18n, 'page.TERMS.TITLE6')}</h3>
                <p>
                    {convertHtmlToReactDomWithParams(
                        getI18nByApp(i18n, 'page.TERMS.TEXT6_1'),
                        discounted
                    )}
                </p>

                <h3>{getI18nByApp(i18n, 'page.TERMS.TITLE7')}</h3>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT7_1')}</p>
                <ul>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT7_2')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT7_3')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT7_4')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT7_5')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT7_6')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT7_7')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT7_8')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT7_9')}</li>
                </ul>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT7_10')}</p>

                <h3>{getI18nByApp(i18n, 'page.TERMS.TITLE8')}</h3>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT8_1')}</p>
                <ul>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT8_2')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT8_3')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT8_4')}</li>
                </ul>

                <h3>{getI18nByApp(i18n, 'page.TERMS.TITLE9')}</h3>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT9_1')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT9_2')}</p>

                <h3>{getI18nByApp(i18n, 'page.TERMS.TITLE10')}</h3>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT10_1')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT10_2')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT10_3')}</p>
                <p>
                    {convertHtmlToReactDomWithParams(
                        getI18nByApp(i18n, 'page.TERMS.TEXT10_4'),
                        discountedPlural
                    )}
                </p>
                <ul>
                    <li>
                        {convertHtmlToReactDomWithParams(
                            getI18nByApp(i18n, 'page.TERMS.TEXT10_5'),
                            discounted
                        )}
                    </li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT10_6')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT10_7')}</li>
                </ul>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT10_8')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT10_9')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT10_10')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT10_11')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT10_12')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT10_13')}</p>
                <p>
                    {convertHtmlToReactDomWithParams(
                        getI18nByApp(i18n, 'page.TERMS.TEXT10_14'),
                        `${PATH.LEGAL_NOTICE_PATH}#personal-data`
                    )}
                </p>

                <div id="cookie-policy" />
                <h3>{getI18nByApp(i18n, 'page.TERMS.TITLE11')}</h3>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT11_1')}</p>
                <p>
                    <u>{getI18nByApp(i18n, 'page.TERMS.TEXT11_2')}</u>
                </p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT11_3')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT11_4')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT11_5')}</p>
                <ul>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT11_6')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT11_7')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT11_8')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT11_9')}</li>
                </ul>
                <p>
                    <u>{getI18nByApp(i18n, 'page.TERMS.TEXT11_10')}</u>
                </p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT11_1')}</p>
                <ul>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT11_12')}</li>
                    <li>{getI18nByApp(i18n, 'page.TERMS.TEXT11_13')}</li>
                </ul>
                <p>
                    <u>{getI18nByApp(i18n, 'page.TERMS.TEXT11_14')}</u>
                </p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT11_15')}</p>
                <p>
                    {convertHtmlToReactDomWithParams(
                        getI18nByApp(i18n, 'page.TERMS.TEXT11_16'),
                        `${PATH.LEGAL_NOTICE_PATH}#cookie-policy`
                    )}
                </p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT11_17')}</p>

                <h3>{getI18nByApp(i18n, 'page.TERMS.TITLE12')}</h3>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT12_1')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT12_2')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT12_3')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT12_4')}</p>

                <h3>{getI18nByApp(i18n, 'page.TERMS.TITLE13')}</h3>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT13_1')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT13_2')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT13_3')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT13_4')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT13_5')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT13_6')}</p>

                <h3>{getI18nByApp(i18n, 'page.TERMS.TITLE14')}</h3>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT14_1')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT14_2')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT14_3')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT14_4')}</p>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT14_5')}</p>

                <h3>{getI18nByApp(i18n, 'page.TERMS.TITLE15')}</h3>
                <p>{getI18nByApp(i18n, 'page.TERMS.TEXT15_1')}</p>
            </TermsPageContainer>
        );
    }
}

TermsPage.propTypes = {
    i18n: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        i18nCommon: state.i18n.common
    };
}

export default withTemplate(connect(mapStateToProps)(TermsPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/terms/TermsPage.js